import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import React, { useRef } from "react";

const PercentageBar: React.FC<{
  label: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  totalParams: number;
  totalRules: number;
}> = ({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  onChange,
  totalParams,
  totalRules,
}) => {
    const increase = () => {
      if (value + step <= max) onChange(value + step);
    };

    const decrease = () => {
      if (value - step >= min) onChange(value - step);
    };

    const percentage = ((value - min) / (max - min)) * 100;

    const inputRef = useRef<HTMLInputElement>(null);

    return (
      <div className="w-full rounded-xl border overflow-hidden">
        <div className="card_bg_head flex gap-2 fs-14 bg-oceangreen ">
          {label}
        </div>

        <div className="flex items-center gap-4 px-4 pt-[18px]">
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            style={{ "--value": `${percentage}%` } as React.CSSProperties}
            className="custom-slider flex-1 h-2 rounded-lg appearance-none cursor-pointer"
          />

          <div className="flex items-center justify-between border rounded-lg p-2">

            <div className="flex items-center">
              <input
                ref={inputRef}
                type="number"
                value={value === 0 ? '' : value}
                onFocus={(e) => {
                  if (value === 0) e.target.value = '';
                }}
                onBlur={(e) => {
                  if (e.target.value === '') onChange(0);
                }}
                onChange={(e) => {
                  let val = Number(e.target.value);
                  if (val > 100) val = 100;
                  if (val < 0) val = 0;
                  onChange(val);
                }}
                className="font-semibold w-7 text-center outline-none"
              />
              <span
                className="font-semibold cursor-text"
                onClick={() => inputRef.current?.focus()}
              >
                %
              </span>
            </div>

            <div className="flex flex-col leading-none gap-y-1 pl-2">
              <button
                onClick={increase}
                className="color-primary h-3 flex items-center justify-center"
              >
                <ArrowDropUp />
              </button>
              <button
                onClick={decrease}
                className="color-primary h-3 flex items-center justify-center"
              >
                <ArrowDropDown />
              </button>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-6 px-4 py-[18px]">
          <div className="flex items-center gap-1">
            <span className="fs-12 color-sub-text">Total Parameters</span>
            <span>:</span>
            <span className="fs-14">{totalParams}</span>
          </div>

          <div className="flex items-center gap-1">
            <span className="fs-12 color-sub-text">Total Rules</span>
            <span>:</span>
            <span className="fs-14">{totalRules}</span>
          </div>
        </div>
      </div>
    );
  };

export default PercentageBar;
